import { render, staticRenderFns } from "./CrossPageLink.vue?vue&type=template&id=6aa66dcb"
import script from "./CrossPageLink.vue?vue&type=script&lang=js"
export * from "./CrossPageLink.vue?vue&type=script&lang=js"
import style0 from "./CrossPageLink.vue?vue&type=style&index=0&id=6aa66dcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports